import React, { useState, useEffect } from 'react'
import {
	startCourseACourse,
	endCourseACourse
} from '../../api/commande'
import moment from 'moment'
import { useSelector } from 'react-redux'
import Modal from 'react-modal'
import ActionModal from '../ValidationModal/ActionModal'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
function CourseACourseHorizontal({
	commande,
	onClickDetails = () => { },
	onClickSignaler = () => { },
	onClickSigner = () => { },
	hideStatus = false,
	hideTransfert = true,
	hideSignaler,
	setUpdateStatus,
}) {
	const [statut, setStatut] = useState(commande.statut)
	const user = useSelector(state => state.auth.user)
	const token = useSelector((state) => state.auth.token);
	const [modalIsOpenStatusEnCours, setModalIsOpenStatusEnCours] = useState(false)
	const [loading, setLoading] = useState(false)
	const [modalIsOpenStatusSendSMS, setModalIsOpenStatusSendSMS] = useState(false)
	const [modalIsOpenStatusTerminer, setModalIsOpenStatusTerminer] = useState(false);

	const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
	const [isTablette, setIsTablette] = useState(() => window.innerWidth <= 1024 && window.innerWidth > 768);

	useEffect(() => {
		const checkScreen = () => {
			const width = window.innerWidth;

			setIsMobile(width <= 768);
			setIsTablette(width > 768 && width <= 1024);
		};
		checkScreen();
		window.addEventListener('resize', checkScreen);

		return () => window.removeEventListener('resize', checkScreen);
	}, []);

    const{t} = useTranslation();
	return (
		<div
			style={{
				width: '100%',
				background: '#E4EAF0',
				display: 'grid',
				gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : isTablette ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)',
				gap: '10px',
				padding: '1rem',
				borderRadius: 10,
				alignItems: 'flex-start',
				justifyContent: 'space-between',
				marginBottom: 10,
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
				}}
			>
				<span
					style={{
						fontWeight: 'bold',
						color: '#51C7F2',
						marginBottom: 3,
					}}
				>
					{t("course_à_course")} {!!commande ? ' N°' + commande.__id : ''} /{' '}
					<span style={{ color: '#1C63C5' }}>
						{commande.temporisation === 'immediat'
							? t("immédiate")
							: t("planifiée")}
					</span>
				</span>

				<span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,
					}}
				>
					{t("transport_date")} :{' '}
					<span
						style={{ color: '#838EAB', fontWeight: 'bolder' }}
					>
						{moment(commande.date_transport).format('DD/MM/YYYY')}
					</span>
				</span>
				{commande?.createdAt && <span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,
					}}
				>
					{t("creation_date")} :{' '}
					<span
						style={{ color: '#838EAB', fontWeight: 'bolder' }}
					>
						{moment(commande?.createdAt).format('DD/MM/YYYY')}
					</span>
				</span>}

				<span
					style={{
						marginRight: 13,
						marginBottom: '1rem',
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,
					}}
				>
					{t("start_date")}  {' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{moment(commande?.courses[0]?.date_debut).isValid() ?
							moment(commande?.courses[0]?.date_debut).format('DD/MM/YYYY')
							: commande?.courses[0]?.date_debut
						}{' '}
						{moment(commande?.courses[0]?.heure_debut).isValid() ?
							moment(commande?.courses[0]?.heure_debut).format('hh:mm')
							: commande?.courses[0]?.heure_debut}
						{' '}
						{commande.courses[0]?.adresse_debut?.label}
					</span>

				</span>

				<span
					style={{
						marginRight: 13,
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,
					}}
				>
					{t("end_date")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{moment(commande?.courses[0]?.date_fin).isValid() ?
							moment(commande?.courses[0]?.date_fin).format('DD/MM/YYYY')
							: commande?.courses[0]?.date_fin
						}{' '}
						{moment(commande.courses[0]?.heure_fin).isValid() ?
							moment(commande.courses[0]?.heure_fin).format('HH:mm')
							: commande.courses[0]?.heure_fin}
						{' '}
						{commande.courses[0]?.adresse_fin?.label}
					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,
					}}
				>
					{t("payment_status")} :{' '}
					<span
						style={{ color: '#838EAB', fontWeight: 'bolder' }}
					>
						{commande?.paymentStatus === 'payé' ? t("paid") : t("unpaid")}

					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,
					}}
				>
					{t("order_status")} :{' '}
					<span
						style={{ color: '#838EAB', fontWeight: 'bolder' }}
					>
						{commande?.statut === "init" && t("not_started")}
						{commande?.statut === "en-cours" && t("in_progress")}
						{commande?.statut === "terminer" && t("completed")}
						{commande?.statut === "annuler" && t("cancelled")}
					</span>
				</span>
				{(!hideTransfert && commande?.recu && commande?.statut === "en-cours") && (
					<span
						style={{
							color: '#838EAB',
							width: '15rem',
							marginTop: 10,
						}}
					>
						{t("transfer_status")} :{' '}
						<span
							style={{ color: '#838EAB', fontWeight: 'bolder' }}
						>
							{commande?.statutTransfert === 'transferé' && t("transferred")}
							{commande?.statutTransfert === "en cours de transfert" && t("in_transfer")}
							{commande?.statutTransfert === "aucun transfert" && t("no_transfers")}

						</span>
					</span>
				)}
				<span
					style={{
						color: '#838EAB',
						marginTop: 10,
					}}
				>
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						+{commande?.courses?.length >= 1 ? commande?.courses.length - 1 : 0} {t("steps")}{' '}
					</span>
					<span
						style={{ cursor: 'pointer' }}
						onClick={onClickDetails}
					>
						{t("view_details")}
					</span>
				</span>
				{user?.role === "client" &&
					<span
						style={{
							color: '#838EAB',
							marginTop: 10,
						}}>
						{t("assignment")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{!commande?.transporterID && t("unassigned")}
							{(commande?.transporterID && !commande.chauffeurID) && t("assigned_transporter")}
							{(commande?.chauffeurID && commande.transporterID) && t("assigned_driver")}
						</span>
					</span>
				}
			</div>

			{/*  */}
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
					height: '100%',

				}}
			>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("number_of_loaders")} :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande?.nombre_rippeur || 0}

					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					Documents :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{
							(commande?.courses
								?.reduce((total, course) => total + (course.files?.length || 0), 0))
						}

					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("internal_refrence")} :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.ref_client}
					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("total_km")} :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.distance}
					</span>
				</span>
				{user?.role === "client" &&
					<span
						style={{
							color: '#838EAB',
							marginBottom: '1rem',

						}}
					>
						{t("assignment")} :{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{!commande.transporterID && t("unassigned")}
							{(commande.transporterID && !commande.chauffeurID) && t("assigned_transporter")}
							{(commande.transporterID && commande.chauffeurID) && t("assigned_driver")}

						</span>
					</span>

				}



			</div>


			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
				}}
			>



				{!hideStatus &&
					<div
						style={{
							//padding: '0.5rem 2rem',
							display: 'flex',
							flexDirection: 'column',
							color: '#838EAB',
							fontSize: 13,
							borderRadius: 5,
							marginBottom: 3,
						}}
					>
						<span
							onClick={() => { setModalIsOpenStatusEnCours(true) }}
							style={{
								padding: '0.3rem 0.7rem',
								background:
									statut === 'en-cours' ? '#C752B6' : '#838EAB',
								color: statut === 'en-cours' ? 'white' : '#9EA8BF',
								borderRadius: 50,
								fontWeight: 'bold',
								marginBottom: 5,
								fontSize: 10,
								cursor: 'pointer',
								width: '5.5rem',
								textAlign : 'center'
							}}
						>
							{t("in_progress")}
						</span>

						<span
							onClick={onClickSignaler}
							style={{
								padding: '0.3rem 0.7rem',
								background: commande?.signaler
									? '#FCC200'
									: '#838EAB',
								color: commande?.signaler ? 'white' : '#9EA8BF',
								cursor: 'pointer',
								borderRadius: 50,
								fontWeight: 'bold',
								marginBottom: 5,
								fontSize: 10,
								width: '5.5rem',
								textAlign : 'center'
							}}
						>
							{t("report")}{' '}
							{commande?.signaler && `+${commande.signalement_count}`}
						</span>

						<span
							onClick={() => { setModalIsOpenStatusTerminer(true) }}
							style={{
								padding: '0.3rem 0.7rem',
								background:
									statut === 'terminer' ? '#0FD39E' : '#838EAB',
								color: statut === 'terminer' ? 'white' : '#9EA8BF',
								borderRadius: 50,
								fontWeight: 'bold',
								marginBottom: 5,
								fontSize: 10,
								cursor: 'pointer',
								width: '5.5rem',
								textAlign : 'center'
							}}
						>
							{t("complete")}
						</span>
						

					</div>
				}
			</div>

			<div
				style={{
					color: '#838EAB',
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
				}}
			>
				<span>
					{t("handling_eq1")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.manutention.includes('Diable') && t("yes")}
					</span>
				</span>
				<span>
					{t("handling_eq2")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.manutention.includes('Transpalette manuel') &&
							t("yes")}
					</span>
				</span>
				<span>
					{t("handling_eq3")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.manutention.includes(
							'Transpalette électrique'
						) && t("yes")}
					</span>
				</span>
				<span>
					{t("handling_eq4")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.manutention.includes('Sangle') && t("yes")}
					</span>
				</span>

				<span>
					{t("ppe_eq1")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Casque') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq2")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Gants') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq3")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Masque') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq4")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Lunettes') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq5")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Chaussure de sécurité') &&
							t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq6")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Gilet de visibilité') && t("yes")}
					</span>
				</span>
			</div>
			<div
				style={{
					width: isMobile ? '50%' : '',
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
					marginTop: 35,
				}}
			>


				<button
					onClick={onClickDetails}
					style={{
						padding: '0.5rem 1.5rem',
						background: '#51C7F2',
						border: 'none',
						cursor: 'pointer',
						color: 'white',
						borderRadius: 7,
						marginTop: 5,
						fontFamily: 'Montserrat',
						fontWeight: 'bold',

					}}
				>
					{t("view_details")}
				</button>
				{commande.statut === "en-cours" &&
					<button
						onClick={onClickSigner}
						style={{
							padding: '0.5rem 1.5rem',
							background: '#51C7F2',
							border: 'none',
							cursor: 'pointer',
							color: 'white',
							borderRadius: 7,
							marginTop: 5,
							fontFamily: 'Montserrat',
							fontWeight: 'bold',
						}}
					>
						{t("sign")}
					</button>
				}

				{hideStatus && !hideSignaler &&
					<button
						onClick={onClickSignaler}
						style={{
							padding: '0.5rem 1.5rem',
							background: '#838EAB',
							border: 'none',
							cursor: 'pointer',
							color: 'white',
							borderRadius: 7,
							marginTop: 5,
							fontFamily: 'Montserrat',
							fontWeight: 'bold',
						}}
					>
						{t("reports")}
					</button>
				}

			</div>
			<Modal
				isOpen={modalIsOpenStatusSendSMS}
				onRequestClose={() => { }}
				style={{
					overlay: {
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.45)',
					},
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						marginRight: '-50%',
						transform: 'translate(-50%, -50%)',
						width: '20rem', // Taille réduite
						borderRadius: 19,
					},
				}}
				contentLabel='Example Modal'
			>
				<div
					style={{
						fontFamily: 'Montserrat',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: 15,
						textAlign: 'center',
					}}
				>
					<div
						style={{
							marginTop: 20,
						}}
					>
					{t("complete_order_error")}</div>

					<button
						onClick={() => {
							setModalIsOpenStatusSendSMS(false);
						}}
						style={{
							padding: '0.5rem 1rem',
							background: '#50F5A9',
							border: 'none',
							cursor: 'pointer',
							color: 'white',
							borderRadius: 7,
							marginTop: 30,
						}}
					>
						OK
					</button>
				</div>
			</Modal>

			<ActionModal
				isOpen={modalIsOpenStatusEnCours}
				onRequestClose={() => setModalIsOpenStatusEnCours(false)}
				title="Confirmation"
				message={t("start_order_confirmation")}
				onConfirm={async () => {
					setLoading(true)
					try {
						const response = await startCourseACourse(commande._id, token)
						toast.success(response.message, {
							style: {
								fontFamily: 'Montserrat',
							},
						})
						setUpdateStatus(true)
					} catch (error) {
						toast.error(error.response?.data.error || t("error_updating_mission_status"), {
							style: {
								fontFamily: 'Montserrat',
							},
						})

					} finally {
						setModalIsOpenStatusEnCours(false)
						setLoading(false)
					}
				}}
				onCancel={() => {
					setModalIsOpenStatusEnCours(false)
				}}
				isLoading={loading}
			/>
			<ActionModal
				isOpen={modalIsOpenStatusTerminer}
				onRequestClose={() => setModalIsOpenStatusTerminer(false)}
				title="Confirmation"
				message={t("complete_order_confirmation")}
				onConfirm={async () => {
					setLoading(true)
					try {
						const response = await endCourseACourse(commande._id, token)
						toast.success(response.message, {
							style: {
								fontFamily: 'Montserrat',
							},
						})
						setUpdateStatus(true)
					} catch (error) {
						toast.error(error.response?.data.error || t("error_completing_order"), {
							style: {
								fontFamily: 'Montserrat',
							},
						})

					} finally {
						setModalIsOpenStatusTerminer(false)
						setLoading(false)
					}

				}}
				onCancel={() => {
					setModalIsOpenStatusTerminer(false)
				}}
				isLoading={loading}
			/>



		</div>
	)
}

export default React.memo(CourseACourseHorizontal)
